import { render, staticRenderFns } from "./PCheckbox.vue?vue&type=template&id=28dedbff"
import script from "./PCheckbox.vue?vue&type=script&lang=js"
export * from "./PCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports